import { Typography } from 'antd';
import { FC } from 'react';

import { BRAND_COLORS } from '../../../../../../constants/styles';

const { Text } = Typography;

export const ExplainerBox: FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div
    style={{
      background: BRAND_COLORS.secondary.steelBlue,
      border: `1px solid ${BRAND_COLORS.primary.royalBlue}`,
      borderRadius: 6,
      padding: '10px 14px',
    }}
  >
    <Text style={{ color: BRAND_COLORS.secondary.lightSage, fontSize: 12 }}>
      {children}
    </Text>
  </div>
);
